import { Hint } from '@routable/gross-ds';
import React, {} from 'react';
const MicroDepositsNeedVerificationHint = ({ children, className }) => (React.createElement(Hint, { className: className, title: "This payment method can't be used until micro-deposits are verified", type: "warning" }, children));
export default MicroDepositsNeedVerificationHint;
